<template>
    <div class="help">
        <el-link :underline="false" type="danger" icon="el-icon-help" @click="handleOpenHelp">
            Pomoc
        </el-link>
        <el-dialog title="Pomoc" width="95%" @close="handleCloseHelp" :visible="showHelp" :close-on-click-modal="false">
            <img class="help" src="/help.png" alt="Opis funkcjonalności" />
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showHelp: false
        }
    },
    methods: {
        handleOpenHelp() {
            this.showHelp = true
        },
        handleCloseHelp() {
            this.showHelp = false

            // Prevent opening help modal every time
            localStorage.shownHelp = true
        }
    },
    mounted() {
        // If first visit show modal with help
        if (!localStorage.shownHelp) {
            this.handleOpenHelp()
        }
    }
}
</script>

<style lang="less" scoped>
.help {
    max-width: 100%;
}

.el-link {
  margin: 0;
  font-weight: 400;
  font-size: 13px;
}
</style>